import { parseDate, formatDateTime } from './date-fns.utils';
import {
  DefaultDayScheduleStructureProps,
  DateTimeFormat,
  LocationWeekdayWorkingHours,
  ScheduleListItem,
} from './location-schedule.types';

export const is24h = (workingHours: LocationWeekdayWorkingHours) => {
  let { openTime, closeTime } = workingHours;
  // handle both "hh:mm:hh" and "hh:mm" formats
  openTime = openTime.substring(0, 5);
  closeTime = closeTime.substring(0, 5);
  return openTime === '00:00' && closeTime === '24:00';
};

export const formatTime = (_timeStr: string) => {
  // handle both "hh:mm:hh" and "hh:mm" formats
  let timeStr = _timeStr.substring(0, 5);
  // display 24:00 as 12:00 am
  timeStr = timeStr === '24:00' ? '00:00' : timeStr;

  const date = parseDate(timeStr, DateTimeFormat.Time);
  return formatDateTime(date, DateTimeFormat.TimeFull);
};

export const getDefaultDayScheduleStructure = ({
  dayOfWeek,
  periodStartTitle,
  day,
}: DefaultDayScheduleStructureProps): ScheduleListItem => {
  return {
    periodStart: dayOfWeek,
    periodStartTitle: periodStartTitle,
    periodEnd: null,
    periodEndTitle: null,
    open: {
      opens: day.openTime,
      opensTitle: formatTime(day.openTime),
      closes: day.closeTime,
      closesTitle: formatTime(day.closeTime),
      is24h: is24h(day),
    },
    closed: null,
  };
};
